import HTTP from '../common/http-common';

const END_POINT = '/user';

const changePassword = (userName,  newPassword) => HTTP.post(END_POINT + "/change-password",
 {newPassword: newPassword, userName: userName});
const isValid = () => HTTP.get(END_POINT + "/isvalid");
const list = () => HTTP.get(END_POINT, { cache: false });
const isExistUser = (userName, userId) => HTTP.get(END_POINT +  "/username/" + userName + "/" + userId, { cache: false });
const isExistEmail = (email, userId) => HTTP.get(END_POINT +  "/email/" + email + "/" + userId);

const insert = (data) => HTTP.post(END_POINT, {
    username: data.username,
    password: data.password,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    position: data.position,
    superUser: data.superUser
});
const update = (data) => HTTP.post(END_POINT + "/" + data.userId, {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    position: data.position,
    superUser: data.superUser
});

const deleteUser = (userId) => HTTP.delete(END_POINT + "/" + userId);

export {
    changePassword,
    list,
    isExistUser,
    isExistEmail,
    insert,
    update,
    deleteUser,
    isValid
}